import { makeElement } from '../helpers/componentHelpers';
import './LibToast.scss';
import { popupIcon } from "../helpers/PopupLevel";
export function libToast(level, title, body, options = {}) {
    var _a;
    const config = Object.assign({}, {
        targetQuery: 'body',
        liveMillis: level == 'error' ? 'infinite' : level == 'success' ? 5000 : 10000,
        delayMillis: 0,
        icon: popupIcon(level),
        arrowLink: null,
    }, options);
    const el = makeElement(`
        <div class="lib-toast _${level} _closed">
            <div class="lib-toast-icon"><i class="${config.icon}"></i></div>
            <div class="lib-toast-title">${title}</div>
            <p class="lib-toast-body">${body}</p>
            <button class="lib-toast-close"><i class="fa fa-times"></i></button>
            ${config.arrowLink ? `<a class="lib-arrow-link" href="${config.arrowLink.href}">${config.arrowLink.content}</a>` : ''}
        </div>
    `);
    const closeMessage = () => {
        el.classList.add('_closed');
        setTimeout(() => {
            el.remove();
        }, 500);
    };
    (_a = document.querySelector(config.targetQuery)) === null || _a === void 0 ? void 0 : _a.appendChild(el);
    setTimeout(() => {
        var _a;
        el.classList.remove('_closed');
        (_a = el.querySelector('.lib-toast-close')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', closeMessage);
        if (config.liveMillis !== 'infinite') {
            const liveMillis = config.liveMillis;
            const timerId = setTimeout(closeMessage, liveMillis);
            el.addEventListener('mouseenter', function () {
                clearTimeout(timerId);
            });
            el.addEventListener('mouseleave', function () {
                setTimeout(closeMessage, liveMillis);
            });
        }
    }, config.delayMillis);
}
export function buildLibToast(defaultOptions = {}) {
    return (level, title, body, options) => libToast(level, title, body, Object.assign({}, defaultOptions, options));
}
//# sourceMappingURL=LibToast.js.map